/**
 * Pen Test Issue #1 (CVSS 8.6): the rollout switch for server-authoritative
 * storefront pricing. Flip it by changing the constant below in a pull request.
 *
 * SHADOW: the storefront behaves exactly as it did before the
 * server-authoritative pricing work. The new logic still runs where it is safe
 * to, but only to log what it would have done, so the quote, the card, the
 * saved bought treatments and the displayed price can be compared on real
 * traffic first.
 *
 * ENFORCED: the new behavior is live. The card is authorized for hex-pc's
 * quote, the client price never reaches hex-pc, a cart is saved in one call,
 * the saved total is checked against the authorized amount, and discounts
 * round per item like hex-pc.
 *
 * Only the production deployment can be in shadow. Every other build (Vercel
 * previews, dev, staging, local, unit tests) is always enforced, so the UI
 * specs and manual testing keep exercising the new behavior.
 *
 * The browser and the server actions read the same build, so they cannot
 * disagree, and no request can choose the mode.
 */
const SHADOW_MODE_IN_PRODUCTION = true;

export function isStorefrontPricingShadowMode(): boolean {
  // Must stay a literal `process.env.NEXT_PUBLIC_*` read so Next inlines it.
  // The same variable decides production for the account redirect URLs.
  return (
    SHADOW_MODE_IN_PRODUCTION &&
    process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
  );
}
